import { IDatasource, IGetRowsParams } from 'ag-grid-community';
import { XeroService } from '../services/xero.service';

export class XeroJobDataSource implements IDatasource {
  constructor(private xeroService: XeroService, private values: any) {}

  getRows(params: IGetRowsParams): void {
    const qsParams: any = {
      limit: params.endRow,
      offset: params.startRow
      // orderBy: (this.order.order) ? this.order.order : 'id',
      // orderDir: (this.order.direction) ? this.order.direction : 'asc'
    };

    this.xeroService
      .getReportData(qsParams, this.values)
      .subscribe((results) => {
        let lastRow = -1;
        if (results.length <= params.endRow) {
          lastRow = results.length + 1;
        }
        params.successCallback(results, lastRow);
      });
  }
}
